module.exports = __webpack_public_path__ + "img/AS.e6a6d2f8.png";